<template>
  <div class="account-think-page" v-resize="onResizePage">
    <account-think-banner class="at-banner"/>
<!--    <img class="at-banner" src="@/components/AccountThink/at_dashboard.svg" alt="">-->
<!--    <div class="account-think-page__wrapper">-->
<!--      <h1 class="t-title">totalflow Accounting Cycle</h1>-->
<!--      <div class="grid-wrapper">-->
<!--        <div id="box-0" class="box-0" style="text-align: right;">-->
<!--&lt;!&ndash;          0&ndash;&gt;-->
<!--          Interpreting<br>Phase-->
<!--        </div>-->
<!--        <div id="box-1" class="box box-1">-->
<!--          <h2 class="column-header">-->
<!--            Close Period-->
<!--          </h2>-->
<!--&lt;!&ndash;          1&ndash;&gt;-->
<!--          <div><b>Reports</b></div>-->
<!--          <div class="items">-->
<!--            <div>Balance Sheet</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div id="box-13" class="box-13">-->
<!--          <span>-->
<!--            Summarizing<br>-->
<!--            Phase-->
<!--          </span>-->
<!--        </div>-->
<!--        <div id="box-2" class="box box-2 left-alignment">-->
<!--&lt;!&ndash;          2&ndash;&gt;-->
<!--          <div><b>Reports</b></div>-->
<!--          <div class="items">-->
<!--            <div>Income Statement</div>-->
<!--            <div>Statement of Cashflows</div>-->
<!--            <div>Balance Sheet</div>-->
<!--            <div>Statement of Capital</div>-->
<!--            <div>Auditing</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div id="box-18" class="box-18">-->
<!--            <el-button size="mini">OPEN WORKSHEET</el-button>-->
<!--        </div>-->
<!--        <div id="box-3" class="box box-3">-->
<!--          <h2 class="column-header">-->
<!--            Start Period-->
<!--          </h2>-->
<!--&lt;!&ndash;          3&ndash;&gt;-->
<!--          <div><b>Reversing Entries</b></div>-->
<!--          <div class="items">-->
<!--            <div>Account Adjustments</div>-->
<!--            <div>Optional</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div id="box-4" class="box box-4">-->
<!--&lt;!&ndash;          4&ndash;&gt;-->
<!--          <div><b>Trial Balance</b></div>-->
<!--          <div class="items">-->
<!--            <div>Post-Closing</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div id="box-5" class="box box-5">-->
<!--          <div><b>Transactions</b></div>-->
<!--          <div class="items">-->
<!--            <div>Identification and Measurement</div>-->
<!--            <div>Source Documents</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div id="box-6" class="box box-6">-->
<!--&lt;!&ndash;          6&ndash;&gt;-->
<!--          <div><b>Account Closing</b></div>-->
<!--          <div class="items">-->
<!--            <div>-->
<!--              Add Closing Journal Entries-->
<!--            </div>-->
<!--            <div>(System Automated)</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div id="box-7" class="box box-7 left-alignment">-->
<!--          &lt;!&ndash;          7&ndash;&gt;-->
<!--          <div><b>Entries to Journals</b></div>-->
<!--          <div class="items">-->
<!--            <div><router-link :to="`/journal-and-gl?companyId=${this.$route.query.companyId}&tab=sales`">Sales</router-link></div>-->
<!--            <div><router-link :to="`/journal-and-gl?companyId=${this.$route.query.companyId}&tab=purchase`">Purchase</router-link></div>-->
<!--            <div><router-link :to="`/journal-and-gl?companyId=${this.$route.query.companyId}&tab=cashReceipts`">Cash Receipts</router-link></div>-->
<!--            <div><router-link :to="`/journal-and-gl?companyId=${this.$route.query.companyId}&tab=cashDisbursements`">Cash Disbursements</router-link></div>-->
<!--            <div><router-link :to="`/journal-and-gl?companyId=${this.$route.query.companyId}&tab=salesReturns`">Sales Returns</router-link></div>-->
<!--            <div><router-link :to="`/journal-and-gl?companyId=${this.$route.query.companyId}&tab=purchaseReturns`">Purchase Returns</router-link></div>-->
<!--            <div><router-link :to="`/journal-and-gl?companyId=${this.$route.query.companyId}&tab=general`">General</router-link></div>-->
<!--            <div>Payroll</div>-->
<!--            <div>Templates</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div id="box-8" class="box box-8">-->
<!--          &lt;!&ndash;          8&ndash;&gt;-->
<!--          <div><b>Report</b></div>-->
<!--          <div class="items">-->
<!--            <div>Income Statements</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div id="box-9" class="box box-9 left-alignment">-->
<!--&lt;!&ndash;          9&ndash;&gt;-->
<!--          <div><b>Postings to ledgers</b></div>-->
<!--          <div class="items">-->
<!--            <div><router-link :to="`/general-ledger?companyId=${this.$route.query.companyId}`">General Ledger (Summary of Accounts)</router-link></div>-->
<!--            <div>General Ledger (Detail of Accounts)</div>-->
<!--            <div>General Ledger (Subsidiary Accounts)</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div id="box-10" class="box box-10">-->
<!--          <div><b>Trial Balance</b></div>-->
<!--          <div class="items">-->
<!--            <div>Adjusted</div>-->
<!--          </div>-->
<!--&lt;!&ndash;          10&ndash;&gt;-->
<!--        </div>-->
<!--        <div id="box-11" class="box box-11">-->
<!--          <div><b>Account Adjustments</b></div>-->
<!--          <div class="items">-->
<!--            <div>Accruals Prepayments Estimated Items</div>-->
<!--            <div>-->
<!--              <router-link :to="`/journal-and-gl?companyId=${this.$route.query.companyId}&tab=sales`">-->
<!--                Add Adjusting Journal Entries-->
<!--              </router-link>-->
<!--            </div>-->
<!--            <div>(Optional)</div>-->
<!--          </div>-->
<!--&lt;!&ndash;          11&ndash;&gt;-->
<!--        </div>-->
<!--        <div id="box-12" class="box box-12">-->
<!--&lt;!&ndash;          12&ndash;&gt;-->
<!--          <div><b>Trial Balance</b></div>-->
<!--          <div class="items">-->
<!--            <div>Unadjusted</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div id="box-14" class="box-14">-->
<!--          Beginning<br>-->
<!--          Phase-->
<!--&lt;!&ndash;          14&ndash;&gt;-->
<!--        </div>-->
<!--        <div id="box-15" class="box-15">-->
<!--&lt;!&ndash;          15&ndash;&gt;-->
<!--          Recording<br>-->
<!--          Phase-->
<!--        </div>-->
<!--        <div id="box-16" class="box-16">-->
<!--&lt;!&ndash;          15&ndash;&gt;-->
<!--          Classifying<br>-->
<!--          Phase-->
<!--        </div>-->
<!--        <div id="box-17" class="box-17 box">-->
<!--          <div><b>Standard Accounting Equation</b></div>-->
<!--          <div class="content">-->
<!--            <div>-->
<!--              <span>Assets</span>= Liabilities + Owners Equity-->
<!--            </div>-->
<!--            <div>-->
<!--              <span>Assets - Liabilities</span>= Owners Equity-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import LeaderLine from "leader-line-vue";
import resize from 'vue-resize-directive'
import AccountThinkBanner from "../components/AccountThink/AccountThinkBanner";

export default {
  name: "AccountThink",
  components: {AccountThinkBanner},
  directives: {
    resize
  },
  data() {
    return {
      liner0: null,
      liner1: null,
      liner2: null,
      liner3: null,
      liner4: null,
      liner5: null,
      liner6: null,
      liner7: null,
      liner8: null,
      liner9: null,
      liner10: null,
      liner11: null,
      liner12: null,
      liner13: null,
      liner14: null,
      liner15: null,
      liner16: null,
      liner17: null,
      liner18: null,
      liner19: null,
      liner20: null,
      LeaderLineOptions: {
        path: 'grid',
        size: 2
      }
    }
  },
  mounted(){
    this.loadGraphicks()
  },
  methods: {
    loadGraphicks() {
      this.liner1 = LeaderLine.setLine(
          document.getElementById('box-1'),
          document.getElementById('box-3'),
          {...this.LeaderLineOptions, ...{ startSocket: 'top', endSocket: 'top' }}
      );
      this.liner2 = LeaderLine.setLine(
          document.getElementById('box-3'),
          document.getElementById('box-5'),
          {...this.LeaderLineOptions, ...{ startSocket: 'bottom', endSocket: 'top', path: 'straight' }}
      );
      this.liner3 = LeaderLine.setLine(
          document.getElementById('box-5'),
          document.getElementById('box-7'),
          {...this.LeaderLineOptions, ...{ startSocket: 'bottom', endSocket: 'top', path: 'straight' }}
      );
      this.liner4 = LeaderLine.setLine(
          document.getElementById('box-7'),
          document.getElementById('box-9'),
          {...this.LeaderLineOptions, ...{ startSocket: 'bottom', endSocket: 'top', path: 'straight' }}
      );
      this.liner5 = LeaderLine.setLine(
          document.getElementById('box-9'),
          document.getElementById('box-12'),
          {...this.LeaderLineOptions, ...{ startSocket: 'bottom', endSocket: 'bottom', middleLabel: LeaderLine.obj.captionLabel('(Accounting Worksheet)', { color: 'black' }) }}
      );
      this.liner6 = LeaderLine.setLine(
          document.getElementById('box-12'),
          document.getElementById('box-11'),
          {...this.LeaderLineOptions, ...{ startSocket: 'top', endSocket: 'bottom', path: 'straight' }}
      );
      this.liner7 = LeaderLine.setLine(
          document.getElementById('box-11'),
          document.getElementById('box-10'),
          {...this.LeaderLineOptions, ...{ startSocket: 'top', endSocket: 'bottom', path: 'straight' }}
      );
      this.liner8 = LeaderLine.setLine(
          document.getElementById('box-10'),
          document.getElementById('box-8'),
          {...this.LeaderLineOptions, ...{ startSocket: 'top', endSocket: 'bottom', path: 'straight' }}
      );
      this.liner9 = LeaderLine.setLine(
          document.getElementById('box-8'),
          document.getElementById('box-6'),
          {...this.LeaderLineOptions, ...{ startSocket: 'top', endSocket: 'bottom', path: 'straight' }}
      );
      this.liner10 = LeaderLine.setLine(
          document.getElementById('box-6'),
          document.getElementById('box-4'),
          {...this.LeaderLineOptions, ...{ startSocket: 'top', endSocket: 'bottom', path: 'straight' }}
      );
      this.liner11 = LeaderLine.setLine(
          document.getElementById('box-4'),
          document.getElementById('box-1'),
          {...this.LeaderLineOptions, ...{ startSocket: 'top', endSocket: 'bottom', path: 'straight' }}
      );
      this.liner0 = LeaderLine.setLine(
          document.getElementById('box-0'),
          LeaderLine.obj.pointAnchor(document.getElementById('box-10'), {
            x: 0,
            y: '100%'
          }),
          {...this.LeaderLineOptions, ...{ startSocket: 'right', endSocket: 'left', path: 'fluid', endPlug: 'behind' }}
      );
      this.liner12 = LeaderLine.setLine(
          document.getElementById('box-0'),
          LeaderLine.obj.pointAnchor(document.getElementById('box-1'), {
            x: 0,
            y: 0
          }),
          {...this.LeaderLineOptions, ...{ startSocket: 'right', endSocket: 'left', path: 'fluid', endPlug: 'behind' }}
      );
      this.liner13 = LeaderLine.setLine(
          document.getElementById('box-13'),
          LeaderLine.obj.pointAnchor(document.getElementById('box-11'), {
            x: 0,
            y: 0
          }),
          {...this.LeaderLineOptions, ...{ startSocket: 'right', endSocket: 'left', path: 'fluid', endPlug: 'behind' }}
      );
      this.liner14 = LeaderLine.setLine(
          document.getElementById('box-13'),
          LeaderLine.obj.pointAnchor(document.getElementById('box-12'), {
            x: 0,
            y: '100%'
          }),
          {...this.LeaderLineOptions, ...{ startSocket: 'right', endSocket: 'left', path: 'fluid', endPlug: 'behind' }}
      );
      this.liner15 = LeaderLine.setLine(
          document.getElementById('box-15'),
          LeaderLine.obj.pointAnchor(document.getElementById('box-5'), {
            x: '100%',
            y: 0
          }),
          {...this.LeaderLineOptions, ...{ startSocket: 'left', endSocket: 'right', path: 'fluid', endPlug: 'behind' }}
      );
      this.liner16 = LeaderLine.setLine(
          document.getElementById('box-15'),
          LeaderLine.obj.pointAnchor(document.getElementById('box-7'), {
            x: '100%',
            y: '100%'
          }),
          {...this.LeaderLineOptions, ...{ startSocket: 'left', endSocket: 'right', path: 'fluid', endPlug: 'behind' }}
      );
      this.liner17 = LeaderLine.setLine(
          document.getElementById('box-14'),
          LeaderLine.obj.pointAnchor(document.getElementById('box-3'), {
            x: '100%',
            y: 0
          }),
          {...this.LeaderLineOptions, ...{ startSocket: 'left', endSocket: 'right', path: 'fluid', endPlug: 'behind' }}
      );
      this.liner18 = LeaderLine.setLine(
          document.getElementById('box-14'),
          LeaderLine.obj.pointAnchor(document.getElementById('box-3'), {
            x: '100%',
            y: '100%'
          }),
          {...this.LeaderLineOptions, ...{ startSocket: 'left', endSocket: 'right', path: 'fluid', endPlug: 'behind' }}
      );
      this.liner19 = LeaderLine.setLine(
          document.getElementById('box-16'),
          LeaderLine.obj.pointAnchor(document.getElementById('box-9'), {
            x: '100%',
            y: 0
          }),
          {...this.LeaderLineOptions, ...{ startSocket: 'left', endSocket: 'right', path: 'fluid', endPlug: 'behind' }}
      );
      this.liner20 = LeaderLine.setLine(
          document.getElementById('box-16'),
          LeaderLine.obj.pointAnchor(document.getElementById('box-9'), {
            x: '100%',
            y: '100%'
          }),
          {...this.LeaderLineOptions, ...{ startSocket: 'left', endSocket: 'right', path: 'fluid', endPlug: 'behind' }}
      );
    },
    onResizePage() {
      this.liner0.position();
      this.liner1.position();
      this.liner2.position();
      this.liner3.position();
      this.liner4.position();
      this.liner5.position();
      this.liner6.position();
      this.liner7.position();
      this.liner8.position();
      this.liner9.position();
      this.liner10.position();
      this.liner11.position();
      this.liner12.position();
      this.liner13.position();
      this.liner14.position();
      this.liner15.position();
      this.liner16.position();
      this.liner17.position();
      this.liner18.position();
      this.liner19.position();
      this.liner20.position();
    }
  },
  beforeDestroy() {
    this.liner0.remove()
    this.liner1.remove()
    this.liner2.remove()
    this.liner3.remove()
    this.liner4.remove()
    this.liner5.remove()
    this.liner6.remove()
    this.liner7.remove()
    this.liner8.remove()
    this.liner9.remove()
    this.liner10.remove()
    this.liner11.remove()
    this.liner12.remove()
    this.liner13.remove()
    this.liner14.remove()
    this.liner15.remove()
    this.liner16.remove()
    this.liner17.remove()
    this.liner18.remove()
    this.liner19.remove()
    this.liner20.remove()
  }
}
</script>

<style lang="less" scoped>
  .account-think-page {
    padding: 60px 10px 10px 10px;
    background-color: #ffff;
    min-height: 100vh;
    &__wrapper {
      .t-title {
        text-align: center;
          margin-bottom: 60px;
      }
      .grid-wrapper {
        display: grid;
        grid-template-columns: 100px 1fr 1fr 1fr 100px;
        grid-column-gap: 70px;
        grid-row-gap: 30px;
        grid-template-rows: repeat(9, 75px);
        //padding: 100px;
        .box {
          border: 1px solid black;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: space-between;
          font-size: 14px;
          padding: 4px;
          width: 270px;
          justify-self: center;
          .items {
            text-align: center;
            line-height: 20px;
          }
        }
        .left-alignment {
            justify-content: flex-start;
            .items {
                margin-top: 20px;
                text-align: left !important;
             }
        }
        .box-0 {
          grid-column-start: 1;
          grid-column-end: 2;
          grid-row-start: 3;
          grid-row-end: 4;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .box-13 {
          grid-column-start: 1;
          grid-column-end: 2;
          grid-row-start: 6;
          grid-row-end: 8;
          text-align: right;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .box-14 {
          grid-column-start: 5;
          grid-column-end: 6;
          grid-row-start: 1;
          grid-row-end: 2;
          text-align: left;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .box-15 {
          grid-column-start: 5;
          grid-column-end: 6;
          grid-row-start: 2;
          grid-row-end: 6;
          text-align: left;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .box-16 {
          grid-column-start: 5;
          grid-column-end: 6;
          grid-row-start: 6;
          grid-row-end: 8;
          text-align: left;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .box-1 {
          grid-column-start: 2;
          grid-column-end: 3;
          position: relative;
          .column-header {
            position: absolute;
            left: 0;
            top: -50px;
            font-size: 16px;
            &:before {
              position: absolute;
              content: '';
              background-color: red;
              width: 150px;
              height: 2px;
              left: (100% + 5px);
              top: calc(50% - 1px);
            }
          }
        }
        .box-2 {
          grid-column-start: 3;
          grid-column-end: 4;
          grid-row-start: 1;
          grid-row-end: 3;
        }
        .box-18 {
            grid-column-start: 3;
            grid-column-end: 4;
            grid-row-start: 4;
            grid-row-end: 6;
            display: flex;
            justify-content: center;
            align-items: center;
         }
        .box-3 {
          border: 1px dashed grey;
          grid-column-start: 4;
          grid-column-end: 5;
          position: relative;
          .column-header {
            position: absolute;
            right: 0;
            top: -50px;
            font-size: 16px;
            &:before {
              position: absolute;
              content: '';
              background-color: green;
              width: 150px;
              height: 2px;
              right: (100% + 5px);
              top: calc(50% - 1px);
            }
          }
        }
        .box-4 {
          grid-column-start: 2;
          grid-column-end: 3;
        }
        .box-5 {
          grid-column-start: 4;
          grid-column-end: 5;
        }
        .box-6 {
          grid-column-start: 2;
          grid-column-end: 3;
        }
        .box-7 {
          grid-column-start: 4;
          grid-column-end: 5;
          grid-row-start: 3;
          grid-row-end: 6;
        }
        .box-8 {
          grid-column-start: 2;
          grid-column-end: 3;
        }
        .box-9 {
          grid-column-start: 4;
          grid-column-end: 5;
          grid-row-start: 6;
          grid-row-end: 8;
        }
        .box-10 {
          grid-column-start: 2;
          grid-column-end: 3;
        }
        .box-11 {
          border: 1px dashed grey;
          grid-column-start: 2;
          grid-column-end: 3;
          height: 86px;
        }
        .box-12 {
          grid-column-start: 2;
          grid-column-end: 3;
        }
        .box-17 {
          margin-top: -40px;
          grid-column-start: 3;
          grid-column-end: 4;
          grid-row-start: 9;
          grid-row-end: 10;
          width: 310px;
          .content {
            span {
              margin-right: 5px;
              min-width: 110px;
              max-width: 120px;
              display: inline-block;
            }
          }
        }
      }
    }
  }
  .at-banner {
    width: 100%;
    height: calc(100vh - 80px);
  }
</style>
